import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { ReportNodeFragmentDoc } from '../fragments/reportNode.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReportQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type ReportQuery = { __typename?: 'Query', report?: { __typename?: 'ReportNode', id: string, carNumber?: string | null, crimeTime: any, issueTime: any, location?: string | null, reportNumber: string, source: Types.ComplaintsReportSourceChoices, car?: { __typename?: 'CarNode', id: string, number: string, color?: string | null, carSubModel: { __typename?: 'CarSubModelNode', name: string, localName?: string | null, carModel: { __typename?: 'CarModelNode', name: string, localName?: string | null } } } | null, driver?: { __typename?: 'DriverNode', id: string, phone?: string | null, name: string, email?: string | null } | null, customer?: { __typename?: 'CustomerNode', id: string, email?: string | null, name: string, title?: Types.CustomersCustomerTitleChoices | null } | null, deal?: { __typename?: 'DealNode', id: string, status?: Types.DealsDealStatusChoices | null } | null } | null };


export const ReportDocument = gql`
    query Report($id: ID!) {
  report(id: $id) {
    ...ReportNode
  }
}
    ${ReportNodeFragmentDoc}`;

/**
 * __useReportQuery__
 *
 * To run a query within a React component, call `useReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportQuery(baseOptions: Apollo.QueryHookOptions<ReportQuery, ReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportQuery, ReportQueryVariables>(ReportDocument, options);
      }
export function useReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportQuery, ReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportQuery, ReportQueryVariables>(ReportDocument, options);
        }
export type ReportQueryHookResult = ReturnType<typeof useReportQuery>;
export type ReportLazyQueryHookResult = ReturnType<typeof useReportLazyQuery>;
export type ReportQueryResult = Apollo.QueryResult<ReportQuery, ReportQueryVariables>;